<style xmlns="http://www.w3.org/1999/html">
    .header-home-nav, .home-footer {
        background: url(~@/assets/hometeacher/images/green-green-fon.png) !important;
        padding-bottom: 10px;
    }

</style>

<template>
    <div>
        <div class="container-fluid blue-letters-girl">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / Полугодовой курс скорочтения
                        </div>

                        <h1 class="">Полугодовой курс <span class="skorochteniya">скорочтения</span></h1>
                        <!-- <h1 class="mobile-vers">Полугодовой курс<br> <span class="yellow-span">скорочтения</span></h1> -->

                        <h3>для детей от 6 до 12 лет</h3>
                        <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;"><img
                                src="~@/assets/hometeacher/images/skorochtenie.jpg" alt="Полугодовой курс скорочтения"
                                class="mobile girl-notik"></div>
                        <p>Обучение ребенка быстрому и вдумчивому чтению при помощи уроков-эпизодов и живых
                            онлайн-занятий с преподавателем.</p>
                        <p><span class="strong-black">Ребенок не только научиться читать с высокой скоростью, но будет понимать прочитанное, запоминать текст, анализировать и пересказывать. Мы поможем ребенку освоить техники вдумчивого чтения, расширить угол зрения ребенка, обогатить его словарный запас.</span>
                        </p>

                        <p>Уроки-эпизоды предполагают поэтапное усложнение заданий. После каждого урока ребенок
                            занимается на онлайн-тренажерах, которые закрепляют полученные знания и умения. Занятия
                            чередуются с индивидуальным онлайн-консультациями тренера по скорочтению.</p>

                        <p class="desktop-vers"><span class="blue-fon-text">Личный куратор будет направлять ребенка, решать индивидуальные</span>
                            <br>
                            <span class="blue-fon-text">проблемы, связанные с чтением, и контролировать процесс обучения.</span>
                        </p>

                        <p class="mobile-vers"><span class="blue-fon-text">Личный куратор будет</span><br>
                            <span class="blue-fon-text">направлять ребенка, решать</span><br>
                            <span class="blue-fon-text">индивидуальные проблемы,</span><br>
                            <span class="blue-fon-text">связанные с чтением,</span><br>
                            <span class="blue-fon-text">и контролировать процесс</span><br>
                            <span class="blue-fon-text">обучения.</span></p>

                        <div class="knpk"><a href="javascript:void(0);" @click="tryFree">Подать заявку</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid vkurs">
            <div class="container">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check">
                        <label for="check"><h2 class="iba">Курс "Скорочтение"</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">
                            <img src="~@/assets/hometeacher/images/girl-wow-skor.jpg" alt="Полугодовой курс скорочтения">
                            <div>

                                <p style="font-size: 3px;">&nbsp;</p>

                                <div class="chek"></div>
                                <p><span class="strong-black">30 уроков-эпизодов</span> для детей продолжительностью 30
                                    минут каждый</p>
                                <div class="chek"></div>
                                <p><span class="strong-black">90 онлайн-тренажеров</span></p>
                                <div class="chek"></div>
                                <p><span class="strong-black">90 рабочих листов</span></p>
                                <div class="chek"></div>
                                <p><span class="strong-black">40</span> дополнительных материалов на карточках</p>

                                <p style="font-size: 3px;">&nbsp;</p>

                                <div class="red-chek"></div>
                                <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Первая установочная сессия с преподавателем</span>
                                </p>
                                <div class="red-chek"></div>
                                <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Последующие онлайн-консультации 1 раз в месяц</span>
                                </p>
                                <p>оценка скорости чтения, выявление причин медленного чтения, составление плана
                                    занятий.</p>
                                <div class="red-chek"></div>
                                <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">За дополнительную плату приобретайте индивидуальные онлайн-занятия с преподавателем по предмету.</span>
                                </p>

                            </div>
                            <h3>Длительность всего курса: 6 месяцев. </h3>
                        </div>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2 class="iba desktop-vers">Курс "Скорочтение"</h2>

                        <img src="~@/assets/hometeacher/images/girl-wow-skor.jpg" alt="Полугодовой курс скорочтения">


                        <div class="chek"></div>
                        <p><span class="strong-black">30 уроков-эпизодов</span> для детей продолжительностью 30 минут
                            каждый</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">90 онлайн-тренажеров</span></p>
                        <div class="chek"></div>
                        <p><span class="strong-black">90 рабочих листов</span></p>
                        <div class="chek"></div>
                        <p><span class="strong-black">40</span> дополнительных материалов на карточках</p>
                        <p style="font-size: 3px;">&nbsp;</p>
                        <p style="font-size: 3px;">&nbsp;</p>
                        <div class="red-chek"></div>
                        <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Первая установочная сессия с преподавателем</span>
                        </p>
                        <div class="red-chek"></div>
                        <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Последующие онлайн-консультации 1 раз в месяц</span>
                        </p>
                        <p>оценка скорости чтения, выявление причин медленного чтения, составление плана занятий.</p>
                        <div class="red-chek"></div>
                        <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">За дополнительную плату приобретайте индивидуальные онлайн-занятия с преподавателем по предмету.</span>
                        </p>

                        <h3>Длительность всего курса: 6 месяцев. </h3>
                    </div>

                </div>
            </div>
        </div>
        <div class="container-fluid beigetop"></div>
        <div class="container-fluid beigefon">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <h2>Скорочтение от <br> “Полиглотиков” &ndash;<br>
                            <span class="veselo">по эффективной методике!</span></h2>
                        <p>Перед началом работы над увеличением темпа чтения тренер по скорочтению проведет первую
                            консультацию, чтобы понять, по каким причинам ребенок читает медленно. Даже если ребенок
                            набирает быстрый темп, он может делать это невдумчиво, без понимания и восприятия
                            прочитанного. Выяснив причины, мы составим план занятий. Первый бесплатный урок-эпизод
                            продемонстрирует, как мы учим, какие онлайн-тренажеры, карточки для скачивания вы будете
                            использовать.</p>
                    </div>

                    <div class="col-12 col-sm-5">
                        <img src="~@/assets/hometeacher/images/strlka.png">
                        <div class="knpk-yellow"><a href="javascript:void(0);" @click="tryFree">Попробовать бесплатно</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid beigedown"></div>

        <div class="container-fluid blue-letters-back">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="desktop-vers">Ставьте цели и <span class="viborabonement">выбирайте абонемент:</span>
                        </h2>
                        <h2 class="mobile-vers">Ставьте цели<br>
                            <div class="viborabonement">и выбирайте<br> абонемент:</div>
                        </h2>
                    </div>
                </div>

                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />

            </div>
        </div>

        <div class="container-fluid lessons-how greenback">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h2 class="h2desctop">Результаты наших учеников</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-5 fotokind">
                        <img src="~@/assets/hometeacher/images/olimpiya.png" alt="Олимпия">
                    </div>
                    <div class="col-12 col-sm-7 textresult">
                        <div class="nameresult">Олимпия (7 лет)</div>
                        <p>Поздравляем Олимпию (7 лет) с успешным окончанием курса # скорочтение для школьников! За 4,5
                            месяца, а это 36 академических часов, Олимпия показала потрясающие результаты &ndash; с 75
                            слов в минуту скорость чтения достигла 250 слов в минуту при 100% усвоении текста!!!!!</p>

                        <div class="row">
                            <div class="col-12">
                                <div class="center-delimeter-green"></div>
                            </div>
                        </div>

                        <table style="width:100%; border:none;">
                            <tr>
                                <td>
                                    <div class="shapka"></div>
                                    <div class="stalo">Стало <img src="~@/assets/hometeacher/images/stalo.png"></div>
                                    <div class="bilo">Было <img src="~@/assets/hometeacher/images/bilo.png"></div>
                                </td>
                                <td>
                                    <div class="shapka">Скорочтение</div>
                                    <div class="stalo">120 слов/мин</div>
                                    <div class="bilo">50 слов/мин</div>
                                </td>
                                <td>
                                    <div class="shapka">Память</div>
                                    <div class="stalo">28/30 картинок</div>
                                    <div class="bilo">4/10 картинок</div>
                                </td>
                                <td>
                                    <div class="shapka">Мышление</div>
                                    <div class="stalo">6/6 задач</div>
                                    <div class="bilo">4/6 задач</div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="row mobile-vers kray">
                    <div class="col-12 fotokind">
                        <img src="~@/assets/hometeacher/images/olimpiya-mobile.jpg" alt="Олимпия">
                    </div>
                </div>
                <div class="row mobile-vers">
                    <div class="col-12">
                        <div class="nameresult">Олимпия (7 лет)</div>
                        <div class="shapka">Скорочтение</div>
                        <div class="stalo"><span class="fz16px">Стало:</span> 120 слов/мин</div>
                        <div class="bilo"><span class="fz16px">Было:</span> 50 слов/мин</div>
                        <div class="row">
                            <div class="col-12">
                                <div class="center-delimeter-green"></div>
                            </div>
                        </div>
                        <div class="shapka">Память</div>
                        <div class="stalo"><span class="fz16px">Стало:</span> 28/30 картинок</div>
                        <div class="bilo"><span class="fz16px">Было:</span> 4/10 картинок</div>
                        <div class="row">
                            <div class="col-12">
                                <div class="center-delimeter-green"></div>
                            </div>
                        </div>
                        <div class="shapka">Мышление</div>
                        <div class="stalo"><span class="fz16px">Стало:</span> 6/6 задач</div>
                        <div class="bilo"><span class="fz16px">Было:</span> 4/6 задач</div>
                        <div class="row">
                            <div class="col-12">
                                <div class="center-delimeter-green"></div>
                            </div>
                        </div>
                        <p>Поздравляем Олимпию (7 лет) с успешным окончанием курса # скорочтение для школьников! За 4,5
                            месяца, а это 36 академических часов, Олимпия показала потрясающие результаты &ndash; с 75
                            слов в минуту скорость чтения достигла 250 слов в минуту при 100% усвоении текста!!!!!</p>

                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid obuchenie">
            <div class="container">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check1">
                        <label for="check1"><h2 class="iba">Как проходит обучение</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight1"></div>
                                    <div class="bluekrug">1</div>
                                    <p>Подайте заявку на <span
                                            class="strong-black">онлайн-консультацию с тренером</span>, который <span
                                            class="strong-black">оценит скорость чтения</span>, проведет тестирование и
                                        даст рекомендации.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug">2</div>
                                    <p>Каждую неделю ученик проходит по <span
                                            class="strong-black">2 урока-эпизода.</span></p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="bluekrug">3</div>
                                    <p>Во время занятия следует <span class="strong-black">выполнять все задания преподавателя</span>.
                                        И регулярно читайте дома разные тексты предложенными способами.</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug">4</div>
                                    <p><span class="strong-black">Выполняйте домашние задания</span> в формате
                                        онлайн-тренажеров.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug" style="margin-bottom: 70px;">5</div>
                                    <p>Ежемесячно наставник проводит <span class="strong-black">онлайн-встречи</span> с
                                        ребенком и родителями для контроля достижения результатов.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="bluekrug">6</div>
                                    <p><span class="strong-black">Получите поддержку 7/24 в чате</span>, задавая любые
                                        вопросы.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2>Как проходит обучение</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight1"></div>
                        <div class="bluekrug">1</div>
                        <p>Подайте заявку на <span class="strong-black">онлайн-консультацию с тренером</span>, который
                            <span class="strong-black">оценит скорость чтения</span>, проведет тестирование и даст
                            рекомендации.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">2</div>
                        <p>Каждую неделю ученик проходит по <span class="strong-black">2 урока-эпизода.</span></p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="bluekrug">3</div>
                        <p>Во время занятия следует <span
                                class="strong-black">выполнять все задания преподавателя</span>. И регулярно читайте
                            дома разные тексты предложенными способами.</p>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-9">
                        <img src="~@/assets/hometeacher/images/strelka-krivaya.png" class="strelka-krivaya">
                    </div>

                    <div class="col-12 col-sm-3">
                        <img src="~@/assets/hometeacher/images/hello.png" class="hello">
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">4</div>
                        <p><span class="strong-black">Выполняет домашние задания</span> в формате онлайн-тренажеров.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">5</div>
                        <p>Ежемесячно наставник проводит <span class="strong-black">онлайн-встречи</span> с ребенком и
                            родителями для контроля достижения результатов.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="bluekrug">6</div>
                        <p><span class="strong-black">Получите поддержку 7/24 в чате</span>, задавая любые вопросы.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter desktop-vers" style="margin-top: 90px;"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid liniya mobile-vers"></div>
        <div class="container-fluid white-bg no-shadow sm-video" style="padding-top: 0px;">
            <div class="container align-middle">

                <div class="row">
                    <div class="col-12">
                        <h2 style="margin-top: 40px; line-height: 1.3; text-align: center;">По окончании обучения<br>
                            <span class="sertifikat">ребенок получает сертификат</span></h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="text-align: center;">
                        <a href="~@/assets/hometeacher/images/skor-sertifikat.jpg" target="_blank"><img
                                src="~@/assets/hometeacher/images/skor-sertifikat-resize.jpg"></a>
                    </div>
                </div>

            </div>
        </div>

        <div class="container-fluid bigwavetop desktop-vers"></div>
        <div class="container-fluid liniya mobile-vers"></div>

        <div class="container-fluid white-bg no-shadow sm-video">
            <div class="container align-middle">
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2>Смотрите видео о наших курсах:</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:3}}">

                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/1g0CirD0N1U" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Курс по скорочтению для детей от языковых центров Полиглотики</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/tXzo-RguObA" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Скорочтение для детей от языковых центров Полиглотики. Урок 1</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/75pHMFbbWKw" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Скорочтение для детей от языковых центров Полиглотики. Урок 2</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/YDl3odNzHBo" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Скорочтение для детей от языковых центров Полиглотики. Урок 3</p>
                            </div>
                        </carousel>
                    </div>
                </div>


                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check3">
                        <label for="check3"><h2>Смотрите видео о наших курсах:</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">

                            <carousel :responsive="{0:{items:1},1000:{items:3}}">

                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/1g0CirD0N1U" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Курс по скорочтению для детей от языковых центров Полиглотики</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/tXzo-RguObA" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Скорочтение для детей от языковых центров Полиглотики. Урок 1</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/75pHMFbbWKw" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Скорочтение для детей от языковых центров Полиглотики. Урок 2</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/YDl3odNzHBo" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Скорочтение для детей от языковых центров Полиглотики. Урок 3</p>
                                </div>
                            </carousel>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="land-t-delimeter desktop-vers" style="margin-top: 0px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid liniya mobile-vers"></div>

        <div class="container-fluid white-bg no-shadow sm-video">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter desktop-vers"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2 class="otzivh2">Отзывы родителей</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:2}}">

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt=""
                                     src="@/assets/hometeacher/images/olesya-dobryakova.jpg">
                                <span class="nameotzyv">Олеся Добрякова</span>
                                <div class="text-otziv">Месяц назад выиграли в розыгрыше курс Скорочтения от
                                    @poliglotiki_rybnoe , он нам оказался очень кстати. Пока можно говорить только о
                                    промежуточных результатах...
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/arina.jpg">
                                <span class="nameotzyv">Арина</span>
                                <div class="text-otziv">Скорочтение вживую! Полиглотики @poliglotiki порадовали! На
                                    осенних каникулах купили детям видеокурс Скорочтение на poliglotiki.com. Цель:
                                    повышение успеваемости в школе...
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt=""
                                     src="@/assets/hometeacher/images/nastyamerkulova.jpg">
                                <span class="nameotzyv">NastyaMerkulova</span>
                                <div class="text-otziv">Вчера начала заниматься скорочтением от Полиглотиков. Скоро буду
                                    читать быстрее всех.
                                </div>
                            </div>

                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt="" src="@/assets/hometeacher/images/no-avatar-1.png">
                                <span class="nameotzyv">Ирина Котова</span>
                                <div class="text-otziv">Мой сын довольно поздно начал говорить и соответственно читать.
                                    С трудом к концу второго класса он читал по слогам и совершенно не понимал
                                    прочитанное...
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
                <div class="row" style="margin-top: 70px; margin-bottom: 50px;">
                    <div class="col-12" style="text-align: center;">
                        <a href="https://poliglotiki.com/home-teacher/course/skorochtenie/details" class="allotzv">Читать
                            все отзывы</a>
                    </div>
                </div>

            </div>
        </div>


        <div class="container-fluid beigetop"></div>
        <div class="container-fluid beigefon">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <h2>Скорочтение от <br> “Полиглотиков” &ndash;<br>
                            <span class="veselo">по эффективной методике!</span></h2>
                        <p>Результат &ndash; ребенок научится: читать быстро и при этом вдумчиво, расширит угол зрения и
                            увеличит словарный запас, сможет запоминать прочитанное и образно мыслить. А значит, с
                            любыми школьными предметами будет справляться самостоятельно и гораздо быстрее.</p>
                    </div>

                    <div class="col-12 col-sm-5">
                        <img src="~@/assets/hometeacher/images/strlka.png">
                        <div class="knpk-yellow"><a href="javascript:void(0);" @click="tryFree">Попробовать бесплатно</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid beigedown-white desktop-vers"></div>
        <div class="container-fluid beigedown mobile-vers"></div>
        <div class="container-fluid last-stav">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="desktop-vers">Ставьте цели и <span class="viborabon-last">выбирайте абонемент:</span>
                        </h2>
                        <h2 class="mobile-vers">Ставьте цели<br>
                            <div class="viborabonement">и выбирайте<br> абонемент:</div>
                        </h2>
                    </div>
                </div>
                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />

            </div>
        </div>

        <Entry/>
    </div>
</template>

<script>
    import carousel from "vue-owl-carousel";
    import moment from 'moment';
    import StudyProductSubscriptionList from "./Study/landing/StudyProductSubscriptionList";
    import studyProductApi from "../data/StudyProductApi";
    import Entry from "./Entry";

    export default {
        components: {
            StudyProductSubscriptionList,
            carousel,
            Entry,
        },
        name: "GodovojKursSkorochteniya",

        data: function () {
            return {
                title: null,
                slug: 'godovoj-kurs-skorochteniya',
                subscriptions: [],
                freeSubscription: null,
                promoSuscription: null,
                courses: [],
            }
        },

        mounted() {
            moment.locale(this.$i18n.locale)
            this.loading = true

            studyProductApi.fetchStudyProductSlug(this.slug)
                .then(response => {
                    this.subscriptions = response.subscriptions.filter(s => {
                        if (s.price <= 0) {
                            this.freeSubscription = s
                            return false
                        }
                        return s.price > 0
                    })
                    this.courses = response.courses

                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

        },

        methods: {
            orderSubscription(subscription) {
                this.$router.push('/subscription/order/' + subscription.idsubscription)
            },
            aboutCourse(course) {
                this.$router.push('/course/' + course.slug + '/details')
            },
            tryFree() {
                if (this.freeSubscription) {
                    this.$router.push('/subscription/order/' + this.freeSubscription.idsubscription)
                }
            }
        },

        metaInfo() {
            return {
                title: 'Полугодовой курс скорочтения',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: 'Полугодовой курс скорочтения для детей от 6 до 12 лет.'
                    },
                    {
                        property: 'og:title',
                        content: 'Полугодовой курс скорочтения для детей',
                    },
                    {
                        property: 'og:description',
                        content: 'Личный куратор будет направлять ребенка, решать индивидуальные проблемы, связанные с чтением, и контролировать процесс обучения.',
                    },
                    {
                        property: 'og:site_name',
                        content: 'Полиглотики',
                    },
                    {
                        property: 'og:type',
                        content: 'website',
                    },
                    {
                        property: 'og:url',
                        content: 'https://poliglotiki.com/home-teacher/godovoj-kurs-skorochteniya',
                    },
                    {
                        property: 'og:image',
                        content: 'https://poliglotiki.com/images/skoro-og-image.jpg',
                    },
                ]
            }
        },
    }
</script>

<style scoped>

    .blue-letters-girl {
        background: url(~@/assets/hometeacher/images/blue-letters-skorochteniye.jpg) no-repeat center;
        text-align: left;
        box-shadow: inset 0 3px 5px #00000038;
        padding-top: 10px;
        min-height: 878px;
    }
    .breadcrumbs {
        font-size: 14px;
        background: #fff;
        max-width: 290px;
        padding-left: 7px;
        border-radius: 10px;
        margin-left: -7px;
    }
    .blue-letters-girl h1 {
        font-size: 50px;
        font-family: Manrope Black;
        margin-top: 15px;
        margin-bottom: 0px;
        color: #000;
    }
    .skorochteniya{
        background: url(~@/assets/hometeacher/images/skorochteniya.png) no-repeat right center;
        padding-left: 8px;
        padding-right: 9px;
        padding-top: 0px;
        padding-bottom: 9px;
    }

    .blue-letters-girl h3 {
        font-size: 30px;
        font-family: Manrope Bold Alt;
        margin-bottom: 20px;
        color: #000;
    }

    .blue-letters-girl p {
        font-size: 20px;
        max-width: 750px;
    }

    .blue-fon-text{
        background: #00b4f1;
        color: #fff;
        border-radius: 15px;
        padding: 2px 10px;
        font-size: 19px;
        font-family: 'Manrope Book';
        margin-left: 0px;
    }

    .knpk {
        border-radius: 35px;
        max-width: 230px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 22px;
        color: #fff;
        padding: 15px 30px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
        margin-top: 30px;
    }
    .knpk:hover {
        background: #49d92c;
    }
    .knpk a {color:#fff;}

    .vkurs {padding-top: 60px;}
    .vkurs h2 {font-size: 40px; font-family: Manrope Bold Alt; color:#262239; margin-bottom: 30px;}
    .vkurs h3 {font-size: 25px; font-family: "Manrope Bold"; color:#231c37; margin-top: 30px;}
    .vkurs img {float: right; margin-right: -35px;}
    .vkurs p{font-size: 20px; margin-left: 35px; line-height: 1.4; color: #000; max-width: 599px !important;
        border-top-right-radius: 30px;  border-bottom-right-radius: 85px;}
    .leftp {margin-left: 0px !important;}
    .red-chek {
        background: url(~@/assets/hometeacher/images/red-chek.png) no-repeat 0 0;
        font-size: 20px; float: left;  width: 25px;  height: 20px;  margin-top: 8px;
    }

    .bezlimit-group{
        background-image: url(~@/assets/hometeacher/images/bezlimit-group.png); line-height: 1.6 !important;
        padding-left: 8px; padding-bottom: 3px; padding-right: 8px;  max-width: 589px !important;
    }
    .onlain-kons{
        background-image: url(~@/assets/hometeacher/images/onlain-kons.png); line-height: 1.4 !important;
        padding-left: 8px; padding-bottom: 0px; padding-right: 8px;  max-width: 654px !important; padding-top: 2px;
    }
    .chek {
        background: url(~@/assets/hometeacher/images/chek.png) no-repeat 0 0;
        font-size: 20px; float: left;  width: 25px;  height: 20px;  margin-top: 8px;
    }

    .beigetop {
        background: url(~@/assets/hometeacher/images/beigetop.png) repeat center;
        width: 100%;  height: 91px; margin-top: 50px;
    }
    .beigedown {
        background: url(~@/assets/hometeacher/images/beigedown.png) repeat center;
        width: 100%;  height: 103px; margin-top: -1px;
    }
    .beigedown-white {
        background: url(~@/assets/hometeacher/images/beigedown-white.png) repeat center;
        width: 100%;  height: 105px;
    }
    .beigefon {
        background: #eac675;
        min-height: 350px;  overflow: hidden; padding-bottom: 0px; padding-top: 30px;
    }
    .beigefon img {
        float: right;  margin-right: -415px;  margin-top: 162px;  height: 33px;  max-width: 100%;
    }
    .beigefon h2 {
        font-family: Manrope Bold Alt;
        font-size: 40px;  color: #fff;
        margin-top: 50px;  line-height: 1.3;
    }
    .beigefon p {color:#fff; font-size: 18px;    line-height: 1.4;  margin-top: 20px;}
    .veselo {
        background-image: url(~@/assets/hometeacher/images/effekt-skor.png);
        padding-left: 8px;  padding-top: 2px; padding-bottom: 8px;
        color: #000;  padding-right: 8px;
    }
    .knpk-yellow {
        border-radius: 35px;  text-align: center;  max-width: 390px;
        font-family: Manrope Bold Alt;  background: -webkit-gradient(linear, left bottom, left top, from(#ffce00), to(#fbfe00));
        font-size: 24px;  padding: 15px 30px;  -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);  text-decoration: none;  margin-top: 145px;
    }
    .knpk-yellow:hover {background: #fbfe00;}
    .knpk-yellow a {color: #000;}
    .blue-letters-back{
        background-image: url(~@/assets/hometeacher/images/blue-letters-back.png);
        margin-top: 0;  padding-bottom: 100px;  text-align: left;  padding-top: 70px;}
    .blue-letters-back h2 {
        font-size: 40px; font-family: "Manrope Black"; color:#262239;
    }
    .viborabonement{
        background-image: url(~@/assets/hometeacher/images/viborabonement.png);
        padding-left: 8px;  padding-top: 1px; padding-bottom: 8px;  padding-right: 8px;
    }
    .abonement{max-width: 254px; min-height: 233px;  border: 1px solid #d9e0e4; background: #fff; text-align: center;
        margin-top: 50px; border-radius: 10px; box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
    }
    .month-1, .month-3, .month-6, .month-12 {
        font-size: 22px; text-align: center; font-family: "Manrope Bold Alt"; margin-bottom: 15px;
    }
    .month-1{ background: url(~@/assets/hometeacher/images/month-1.png) no-repeat center; margin-top: 30px; color:#231c37; }
    .month-3{ background: url(~@/assets/hometeacher/images/month-3.png) no-repeat center; margin-top: 30px; color:#231c37; }
    .month-6{ background: url(~@/assets/hometeacher/images/month-6.png) no-repeat center; margin-top: 30px; color:#231c37; }
    .month-12{ background: url(~@/assets/hometeacher/images/month-12.png) no-repeat center; margin-top: 4px; color:#fff; }
    .price {font-family: "Manrope Bold"; font-size: 30px; color:#72717d;}
    .rubls{font-size: 18px;}
    .econom{font-size: 15px; color:#231c37;margin-bottom: 17px; margin-top: -6px;  text-shadow: 0px 0px 0px rgb(0 0 0); font-weight: bold;}
    .all-course{color:#ed1c24; font-family: "Manrope Black"; font-size: 18px;}
    .abonement a{ border-radius: 35px;  max-width: 230px;  font-family: Manrope Bold Alt;  background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 20px;  color: #fff;  padding: 14px 35px;  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);  text-decoration: none;}
    .abonement a:hover{background:#49d92c;}

    .getpresent{box-shadow: inset 0 3px 5px #00000038; padding-top: 100px;}
    .getpresent h3 {font-size: 30px; font-family: Manrope Bold Alt; color:#262239; margin-bottom: 40px;}

    .toget{
        background-image: url(~@/assets/hometeacher/images/toget.png);
        padding-left: 8px;  padding-top: 3px; padding-bottom: 10px;  padding-right: 8px;
    }
    .bigwavetop {
        background: url(~@/assets/hometeacher/images/bigwavetop.png) no-repeat center;
        width: 100%;  height: 190px;
    }
    .present{width: 220px;
        height: 469px;
        border: 1px solid #d7e1e5;
        margin-right: -1px;
        padding: 20px;
        overflow: hidden;
        margin: 0 auto 10px auto;}
    .present img{border-radius: 10px;}
    .podarok{ margin-left: 95px;  margin-top: -285px;}
    .dific {margin-top: -30px;}
    .present h4 {font-family: "Manrope Bold"; font-size: 18px; color:#262239; line-height: 1; margin-top: -9px; margin-bottom: 12px;}
    .present h4 a {color:#262239;}
    .present p {font-family: "Manrope Book"; color:#4f4d5c; font-size: 14px;    line-height: 1; margin-bottom: 10px;}
    .cennik {font-family: "Manrope Bold"; font-size: 20px; color:#262239;position: absolute; bottom: 20px;}
    .cennik span{color:#4f4d5c; font-size: 16px; font-family: "Manrope Light"; font-weight: bold;}
    .obuchenie {padding-top: 100px; padding-bottom: 60px; box-shadow: inset 0 3px 5px #00000038;}
    .obuchenie h2, .sm-video h2 {font-size: 40px; font-family: Manrope Bold Alt; color:#262239; margin-bottom: 60px;}
    .obuchenie p {font-size: 18px; width: 270px;  line-height: 1.4;}
    .strela{ background-image: url(~@/assets/hometeacher/images/strela.png);
        width: 176px; height: 19px; margin-top: 20px; left: 100px; position: absolute;
    }
    .bluekrug{width: 60px; height: 60px; border: 3px solid #00b4f1; border-radius: 50%;  text-align: center;
        color: #4f4d5c; background: #fff;  padding-top: 10px;  font-size: 24px;  font-family: "Manrope Bold";
        margin-bottom: 20px;  position: relative; z-index: 10;}
    .strelka-krivaya{margin-left: 35px; margin-top: -40px; padding-bottom: 5px; max-width: 100%;}
    .hello{position: absolute; top:-150px; left: -20px}
    .sertifikat{ background-image: url(~@/assets/hometeacher/images/sertifikat.png);
        padding-left: 8px;  padding-top: 3px; padding-bottom: 8px;  padding-right: 8px;}

    .sm-video {padding-top: 80px;}
    .sm-video p {margin-top: -100px; font-size: 18px; font-family: 'Manrope Book'; color: #000; text-align: center;}
    .vidos {
        width: 100%; height: 192px; border-radius: 15px; margin-right: 0!important; margin-bottom: 100px!important;
    }
    .otzivh2 {font-size: 36px !important; font-family: "Manrope Black" !important; color:#231c37 !important; margin-bottom: 60px !important;}
    .indotz {float: left; margin-right: 20px;}
    .nameotzyv { font-size: 21px; font-family: Manrope Bold;  display: block; color:#000;}
    .text-otziv {font-size: 17px; color:#000; line-height: 1.4; margin-top: 10px;}
    .centers-text {max-width: 500px;}
    .allotzv { color: #0493c3;  font-size: 20px;  font-family: "Manrope Bold";
        padding: 15px 30px;    border: 2px solid #0493c3;  border-radius: 30px;
    }
    .allotzv:hover{background: #0493c3; color:#fff;}
    .viborabon-last{
        background-image: url(~@/assets/hometeacher/images/viborabon-last.png);
        padding-left: 8px;  padding-top: 1px; padding-bottom: 8px;  padding-right: 8px;
    }
    .last-stav {padding-top: 70px; padding-bottom: 120px;}
    .last-stav h2 { font-size: 40px; font-family: "Manrope Bold Alt"; color:#262239;}
    .girl-notik {margin-left: -25px; margin-bottom: 20px;max-width: 110%;}
    .liniya {
        background-image: url(~@/assets/hometeacher/images/liniya.png);
        width: 100%;  height: 36px;     margin-top: 30px;
    }

    .greenback {
        background: #5ab947;
        margin-bottom: 0px;
        padding-bottom: 100px;
        box-shadow: inset 0 3px 5px #00000038;
    }

    .h2desctop{
        font-size: 40px;
        font-family: 'Manrope Bold Alt';
        color: #fff;
        margin-top: 60px;
    }

    .fotokind{text-align:center; padding-top:80px;}
    .fotokind img {max-width:100%;}
    .nameresult {
        font-family: Manrope Bold;
        color:#fff;
        font-size:24px;
    }
    .textresult {padding-top:80px; margin-left:-40px;}
    .textresult p {
        color: #fff;
        font-size: 18px;
        margin-top: 20px;
        line-height: 1.5;
        margin-bottom: 25px;
        max-width: 570px
    }
    .center-delimeter-green{
        height: 1px;
        background-color: #87d575;
        margin-top: 35px;
        margin-bottom: 20px;
    }

    .shapka{font-size:16px; color:#caffbb; font-family: 'Manrope Light'; height: 24px;    margin-bottom: 5px;}
    .stalo {font-size:22px; color:#fff; font-family: Manrope Bold;    margin-bottom: 5px;}
    .bilo {font-size:18px; color:#caffbb; font-family: Manrope Bold;}

    @media (max-width: 1199px) {
        .obuchenie {overflow: hidden; }
        .hello {top: -110px; left: -115px;}
        .cennik {position: inherit;}
    }

    @media (max-width: 991px) {
        .abonement a {padding: 10px;}
        .centers-text{max-width: 100%; text-align: center;}
        .vidos{height: 370px;}
        .indotz{float: none; margin-bottom: 20px;}
        .blue-letters-girl h1 {background: none;}
        .bezlimit-group, .onlain-kons {background: none;}
        .obuchenie p {width:100%;}
        .strela{display: none;}
        .hello {top:-160px;}
    }
    input[type="checkbox"] { display: none; }
    label {cursor: pointer; color: #fff;  text-decoration: underline;
        -moz-user-select: -moz-none; -webkit-user-select: none;  user-select: none;
    }
    .block { width: 100%;  display: none;}
    input:checked ~ .block { display: block; }
    .galocka{margin-right: 0px !important; margin-top: -110px; float: right !important;}

    @media (max-width: 575px) {
        .blue-letters-girl{padding-left: 15px !important; padding-right: 15px !important; padding-bottom: 60px;
            background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;}
        .blue-letters-girl h1 {font-size: 40px; line-height: 1.1;}
        .blue-letters-girl h3 {font-size: 22px;    margin-top: 10px;}
        .skorochteniya {
            background-image: url(~@/assets/hometeacher/images/skorochteniya-mob.png);
            font-size: 40px;     padding-left: 12px; padding-top: 9px; padding-bottom: 16px;  padding-right: 7px;}
        .vkurs {padding-left: 15px !important; padding-right: 15px !important; box-shadow: inset 0 3px 5px rgb(0 0 0 / 22%);}
        .vkurs h2 {font-size: 33px;}
        .vkurs img{float: none;  max-width: 80%; margin-right: 0px !important; }
        .beigefon, .blue-letters-back {padding-left: 15px !important; padding-right: 15px !important; padding-top: 0px; padding-bottom: 10px;}
        .beigefon h2 {font-size: 25px;    line-height: 1.5;}
        .beigefon img {display: none;}
        .beigetop {margin-top: 0px; margin-bottom: -1px;}
        .veselo { background-image: url(~@/assets/hometeacher/images/effekt-skor-mob.png);
            padding-left: 8px;  padding-top: 5px; padding-bottom: 10px; font-size: 22px;
            color: #000;  padding-right: 8px;}
        .knpk-yellow {margin-top: 40px; font-size: 20px; padding: 15px;}
        .blue-letters-back h2, .last-stav h2 {font-size: 33px; text-align: center;}
        .viborabonement{ background-image: url(~@/assets/hometeacher/images/viborabonement-mob.png);
            width: 240px; line-height: 1.2; margin: 0 auto;padding-top: 1px; padding-bottom: 2px; margin-bottom: 30px;  margin-top: -10px;}
        .abonement{margin: 0 auto; margin-bottom: 30px;}
        .abonement a {padding: 15px 35px;}
        .getpresent {padding-left: 15px !important; padding-right: 15px !important; padding-top: 60px; text-align: center;}
        .toget{ background-image: url(~@/assets/hometeacher/images/toget-mob.png); text-align: left;
            width: 285px; line-height: 1.2; margin: 0 auto;padding-top: 1px; padding-bottom: 10px; margin-bottom: 30px;  margin-top: -10px;}
        .present{float: none; margin: auto; width:270px; height: 450px; text-align: left; box-shadow: 2px 2px 9px rgb(0 0 0 / 20%); border-radius: 10px;}
        .podarok{margin-left: 145px;}
        .cennik {position: absolute;}
        .obuchenie {padding-left: 15px !important; padding-right: 15px !important; padding-top: 50px; padding-bottom: 0px; margin-bottom: -20px}
        .obuchenie h2 {font-size: 33px;}
        .bluekrug{float: left; margin-right: 10px; margin-bottom: 45px;}
        .sm-video, .last-stav {padding-left: 15px !important; padding-right: 15px !important; padding-top: 0px;}
        .sm-video h2 {font-size: 30px;}
        .sertifikat{ background:none; padding-left: 0px;}
        .vidos {height: 280px;}
        .last-stav{ background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat; padding-bottom: 0px;}
        .h2desctop {color:#fff; margin-top:0px;    line-height: 1.1;    margin-bottom: 40px;    font-size: 30px;}
        .greenback {padding-top: 40px; /*margin-top: 25px;*/ padding-left: 15px !important; padding-right: 15px !important; padding-bottom: 50px;}
        .greenback p {font-size: 18px; color: #fff; line-height: 1.5; margin-top: 5px;}
        .fotokind {padding:0px;}
        .kray {margin-left:-30px; margin-right:-30px;}
        .nameresult {margin-top:30px; margin-bottom:30px;}
        .shapka {color:#ffdb00;    text-shadow: 0px 0px 0px #ffdb00;}
        .stalo {font-size:22px;}
        .bilo {font-size:18px;}
    }

    @media (max-width: 404px) {
        /* veselo { background-image: url(~@/assets/hometeacher/images/effekt-skor-mob.png);
           padding-left: 8px;  padding-top: 5px; padding-bottom: 10px; font-size: 22px;
           color: #000;  padding-right: 8px;}*/
    }
    @media (max-width: 370px) {
        .veselo { font-size: 19px;}
    }
</style>
